/*
 * @CopyRight: 广州仰望星空云科技有限公司
 * @Author: Leven
 * @Email: liwenbo@xinyu668.com
 * @Date: 2023-09-13 17:09:48
 * @LastEditTime: 2024-06-07 17:35:41
 * @Description:
 */
// 第三方
import { createApp } from 'vue'

// 全局
import { Lazyload } from 'vant';
import directives from '@DIRECTIVES';
import '@GLOBAL/api';
import '@GLOBAL/devtools'
import '@GLOBAL/report'
import setSentry from '@GLOBAL/sentry' 
import { constConf } from "@GLOBAL/constConf"
import { initRequest } from '@GLOBAL/request';
import { initBridgeClient } from '@GLOBAL/bridge';
// 业务
import '@STYLES/reset.css';
import { constant } from '@PF/constant'
import register from '@CPF/register'
import router from '@CPF/router'
import App from '@CPF/app.vue';
import jsonName from '@CPF/pb/index.min.json'
import { appRedirect } from '@UTILS/client'

const { IS_APP, IS_PC } = constant

// 实例化bridge
initBridgeClient(IS_APP, IS_PC)

// 加载pb
initRequest(jsonName)

// 马甲包重定向
appRedirect()

// 错误信息,自定义错误捕获匹配,拦截返回true,否则返回false
const customErrHandler = (errMsg) => {
  /* if (
    //.test(errMsg)
  ) return true */
  return false
}

const app = createApp(App)
// 添加指令
Object.keys(directives).forEach(key => app.directive(key, directives[key]))
// 确保监控初始化之后才挂载
setSentry(app, router, customErrHandler).then(_app => {
  // 构建时间
  window.buildTime && console.info('buildTime: ', window.buildTime, constConf?.ORIGIN_PATHNAME)
  _app.use(createPinia()).use(router).use(Lazyload).use(register).mount('#app');
})


